// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active-call-bar {
  background-color: #e8f5e9;
  border-bottom: 2px solid #4caf50;
}

.active-call-bar-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  gap: 16px;
}

.active-call-bar-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.active-call-bar-icon {
  font-size: 20px;
}

.active-call-bar-number {
  font-weight: 600;
  color: #2e7d32;
  font-size: 15px;
}

.active-call-bar-duration {
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 14px;
  color: #558b2f;
  font-weight: 500;
  background: rgba(46, 125, 50, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
}

.active-call-bar-controls {
  display: flex;
  gap: 8px;
  align-items: center;
}

.acb-btn {
  padding: 6px 14px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s, opacity 0.15s;
}

.acb-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.acb-btn-mute {
  background-color: #fff;
  color: #333;
  border: 1px solid #ccc;
}

.acb-btn-mute:hover:not(:disabled) {
  background-color: #f5f5f5;
}

.acb-btn-mute.acb-btn-muted {
  background-color: #f44336;
  color: #fff;
  border-color: #f44336;
}

.acb-btn-mute.acb-btn-muted:hover:not(:disabled) {
  background-color: #d32f2f;
}

.acb-btn-dialpad {
  background-color: #fff;
  color: #333;
  border: 1px solid #ccc;
}

.acb-btn-dialpad:hover:not(:disabled) {
  background-color: #f5f5f5;
}

.acb-btn-dialpad.acb-btn-active {
  background-color: #1976d2;
  color: #fff;
  border-color: #1976d2;
}

.acb-btn-voicemail {
  background-color: #ff9800;
  color: #fff;
}

.acb-btn-voicemail:hover:not(:disabled) {
  background-color: #e68900;
}

.acb-btn-hangup {
  background-color: #f44336;
  color: #fff;
}

.acb-btn-hangup:hover:not(:disabled) {
  background-color: #d32f2f;
}

/* Dialpad */
.active-call-bar-dialpad {
  padding: 0 24px 16px;
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.dialpad-grid {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dialpad-row {
  display: flex;
  gap: 4px;
}

.dialpad-key {
  width: 48px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.1s;
}

.dialpad-key:hover {
  background-color: #e3f2fd;
}

.dialpad-key:active {
  background-color: #bbdefb;
}

.dtmf-display {
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 18px;
  letter-spacing: 2px;
  color: #333;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  min-width: 120px;
  word-break: break-all;
}

/* Transfer button */
.acb-btn-transfer {
  background-color: #fff;
  color: #333;
  border: 1px solid #ccc;
}

.acb-btn-transfer:hover:not(:disabled) {
  background-color: #f5f5f5;
}

.acb-btn-transfer.acb-btn-active {
  background-color: #1976d2;
  color: #fff;
  border-color: #1976d2;
}

/* Recording button */
.acb-btn-recording {
  background-color: #fff;
  color: #333;
  border: 1px solid #ccc;
}

.acb-btn-recording:hover:not(:disabled) {
  background-color: #f5f5f5;
}

.acb-btn-recording.acb-btn-rec-paused {
  background-color: #e65100;
  color: #fff;
  border-color: #e65100;
}

.acb-btn-recording.acb-btn-rec-paused:hover:not(:disabled) {
  background-color: #bf360c;
}

/* Transfer panel */
.active-call-bar-transfer {
  padding: 0 24px 16px;
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.transfer-input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  min-width: 200px;
}

.transfer-input:disabled {
  background-color: #f5f5f5;
  color: #999;
}

.transfer-actions {
  display: flex;
  gap: 8px;
}

.acb-btn-transfer-go {
  background-color: #1976d2;
  color: #fff;
}

.acb-btn-transfer-go:hover:not(:disabled) {
  background-color: #1565c0;
}

.acb-btn-transfer-cancel {
  background-color: #fff;
  color: #333;
  border: 1px solid #ccc;
}

.acb-btn-transfer-cancel:hover:not(:disabled) {
  background-color: #f5f5f5;
}

.coming-soon-badge {
  font-size: 10px;
  font-weight: 500;
  background-color: rgba(255, 255, 255, 0.3);
  padding: 1px 6px;
  border-radius: 3px;
  margin-left: 4px;
  vertical-align: middle;
}

.transfer-note {
  font-size: 12px;
  color: #888;
  font-style: italic;
}

@media (max-width: 768px) {
  .active-call-bar-main {
    flex-direction: column;
    gap: 8px;
  }

  .active-call-bar-controls {
    flex-wrap: wrap;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CallControls/ActiveCallBar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF","sourcesContent":[".active-call-bar {\n  background-color: #e8f5e9;\n  border-bottom: 2px solid #4caf50;\n}\n\n.active-call-bar-main {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 24px;\n  gap: 16px;\n}\n\n.active-call-bar-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.active-call-bar-icon {\n  font-size: 20px;\n}\n\n.active-call-bar-number {\n  font-weight: 600;\n  color: #2e7d32;\n  font-size: 15px;\n}\n\n.active-call-bar-duration {\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: 14px;\n  color: #558b2f;\n  font-weight: 500;\n  background: rgba(46, 125, 50, 0.1);\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.active-call-bar-controls {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.acb-btn {\n  padding: 6px 14px;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s, opacity 0.15s;\n}\n\n.acb-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.acb-btn-mute {\n  background-color: #fff;\n  color: #333;\n  border: 1px solid #ccc;\n}\n\n.acb-btn-mute:hover:not(:disabled) {\n  background-color: #f5f5f5;\n}\n\n.acb-btn-mute.acb-btn-muted {\n  background-color: #f44336;\n  color: #fff;\n  border-color: #f44336;\n}\n\n.acb-btn-mute.acb-btn-muted:hover:not(:disabled) {\n  background-color: #d32f2f;\n}\n\n.acb-btn-dialpad {\n  background-color: #fff;\n  color: #333;\n  border: 1px solid #ccc;\n}\n\n.acb-btn-dialpad:hover:not(:disabled) {\n  background-color: #f5f5f5;\n}\n\n.acb-btn-dialpad.acb-btn-active {\n  background-color: #1976d2;\n  color: #fff;\n  border-color: #1976d2;\n}\n\n.acb-btn-voicemail {\n  background-color: #ff9800;\n  color: #fff;\n}\n\n.acb-btn-voicemail:hover:not(:disabled) {\n  background-color: #e68900;\n}\n\n.acb-btn-hangup {\n  background-color: #f44336;\n  color: #fff;\n}\n\n.acb-btn-hangup:hover:not(:disabled) {\n  background-color: #d32f2f;\n}\n\n/* Dialpad */\n.active-call-bar-dialpad {\n  padding: 0 24px 16px;\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.dialpad-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.dialpad-row {\n  display: flex;\n  gap: 4px;\n}\n\n.dialpad-key {\n  width: 48px;\n  height: 40px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background: #fff;\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.1s;\n}\n\n.dialpad-key:hover {\n  background-color: #e3f2fd;\n}\n\n.dialpad-key:active {\n  background-color: #bbdefb;\n}\n\n.dtmf-display {\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: 18px;\n  letter-spacing: 2px;\n  color: #333;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  min-width: 120px;\n  word-break: break-all;\n}\n\n/* Transfer button */\n.acb-btn-transfer {\n  background-color: #fff;\n  color: #333;\n  border: 1px solid #ccc;\n}\n\n.acb-btn-transfer:hover:not(:disabled) {\n  background-color: #f5f5f5;\n}\n\n.acb-btn-transfer.acb-btn-active {\n  background-color: #1976d2;\n  color: #fff;\n  border-color: #1976d2;\n}\n\n/* Recording button */\n.acb-btn-recording {\n  background-color: #fff;\n  color: #333;\n  border: 1px solid #ccc;\n}\n\n.acb-btn-recording:hover:not(:disabled) {\n  background-color: #f5f5f5;\n}\n\n.acb-btn-recording.acb-btn-rec-paused {\n  background-color: #e65100;\n  color: #fff;\n  border-color: #e65100;\n}\n\n.acb-btn-recording.acb-btn-rec-paused:hover:not(:disabled) {\n  background-color: #bf360c;\n}\n\n/* Transfer panel */\n.active-call-bar-transfer {\n  padding: 0 24px 16px;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.transfer-input {\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  min-width: 200px;\n}\n\n.transfer-input:disabled {\n  background-color: #f5f5f5;\n  color: #999;\n}\n\n.transfer-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.acb-btn-transfer-go {\n  background-color: #1976d2;\n  color: #fff;\n}\n\n.acb-btn-transfer-go:hover:not(:disabled) {\n  background-color: #1565c0;\n}\n\n.acb-btn-transfer-cancel {\n  background-color: #fff;\n  color: #333;\n  border: 1px solid #ccc;\n}\n\n.acb-btn-transfer-cancel:hover:not(:disabled) {\n  background-color: #f5f5f5;\n}\n\n.coming-soon-badge {\n  font-size: 10px;\n  font-weight: 500;\n  background-color: rgba(255, 255, 255, 0.3);\n  padding: 1px 6px;\n  border-radius: 3px;\n  margin-left: 4px;\n  vertical-align: middle;\n}\n\n.transfer-note {\n  font-size: 12px;\n  color: #888;\n  font-style: italic;\n}\n\n@media (max-width: 768px) {\n  .active-call-bar-main {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .active-call-bar-controls {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
